export default __webpack_public_path__ + "static/media/img-5.d158c37c.jpg";